module.exports = __webpack_public_path__ + "img/rejected.2a5b0ab5.svg";